import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { LanguageProvider } from './controller/context/languageContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
  <HashRouter> 
    <App/>
  </HashRouter>
  </LanguageProvider>
  </React.StrictMode>
);
